export default __webpack_public_path__ + "static/media/Priest's Fauld of the Limitless Cipher.0241ec80.jpg";